/* eslint-disable */
import React, { useEffect, useState } from "react";
// import { Stack, Form, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { appUserActivity, deleteAppUserEmails } from "../../../redux/actions/crmActions";
import "../Leadtabs.css";
import { useParams } from 'react-router';
import moment from "moment";
import * as Icon from "react-bootstrap-icons";
// import DeleteModal from "../../../../../shared/DeleteModal";

const Emails = (props) => {
    const { id } = useParams();
    const { authToken } = props;
    const { contactId } = props

    const [deleteId, SetDeleteId] = useState(0);
    const [dltDialog, SetDltDialog] = useState(false);

    const dispatch = useDispatch();

    // const userDetails = useSelector((state) => state.crmLeads.userActivityDetails);
    useEffect(() => {

    //     let idd = id !== undefined ? id : contactId.contact_ids[0].contact_id;
    //    // dispatch(appUserActivity(authToken, idd.toString()));
    //     return () => { 
    //     };
    }, []);

    const getDate = (date) => {
        if (date !== "" && date !== null && date !== "0000-00-00 00:00:00") {
            let d = moment(date).format('DD');
            return d;
        }
    }

    const getMonth = (date) => {
        if (date !== "" && date !== null && date !== "0000-00-00 00:00:00") {
            let m = moment(date).format('MMM');
            return m.toUpperCase();
        }
    }

    const deleteEmail = () => {
        let idd = id !== undefined ? id : contactId.contact_ids[0].contact_id;
        SetDeleteId(0)
        SetDltDialog(false);
        dispatch(deleteAppUserEmails(authToken, [deleteId], idd));
    }

    const hideDialog = () => {
        SetDeleteId(0)
        SetDltDialog(false);
    }

    const openModal = (val) => {

        SetDeleteId(val.id);
        SetDltDialog(true);
    }

    return (
        <div className="offcanvas-body-background">
            {/* {userDetails && ( */}
                <div className="activites">
                    { true ?
                        [...Array(3)].map((item, i) => {
                            return (
                                <div className="grid grid-cols-12 m-2 p-4">
                                    <div  key={i} className="p-1 lg:col-span-2">
                                        <div className="fs-6 fw-bold email-status-date"><strong>{"25" || getDate(item.date)}</strong> <br /> <span>{"May" || getMonth(item.date)}</span></div>
                                    </div>
                                    <div  className="lg:col-span-10" style={{ backgroundColor: '#fff' }}>
                                        <div className="grid grid-cols-12 p-2 lh-base">
                                            <div className="md:col-span-10">
                                                <div className="status-title"><Icon.ClipboardCheck />&nbsp;<strong>Email from</strong>{ " Akansha Jain" }</div>
                                            </div>
                                            <div  className="md:col-span-2">
                                                <Icon.Trash className="text-color" onClick={(e) => openModal(item)} />
                                            </div>
                                        </div>
                                        <div className="grid grid-cols-12 p-2 lh-base email-body">
                                            <div className="mb-3">Hey Aakash,</div>
                                            <div>
                                                {/* <strong>Subject: &nbsp;&nbsp;</strong> */}
                                            {"It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout."}</div>
                                            {/* (item.subject !== "" || item.subject !== null) ? item.subject : "NA"} */}
                                            {/* <div className="p-1 act-notes-templates ml-2" dangerouslySetInnerHTML={{ __html: item.message !== "" ? `<p><strong>&nbsp;&nbsp;Message:&nbsp;&nbsp;</strong></p><div>&nbsp;&nbsp;${item.message}</div>` : "<p><strong>&nbsp;&nbsp;Message:&nbsp; </strong>NA</p>" }}></div> */}
                                        </div>
                                        <div className="grid grid-cols-12 reply-mail">
                                            <div className="grid grid-cols-12 p-2 lh-base">
                                                <div  className="md:col-span-10">
                                                    <div className="status-title"><Icon.Arrow90degDown className="reply-arrow" color="var(--brand-primary)" />&nbsp;<strong>Reply from</strong>{ " Akash Guha" }</div>
                                                </div>
                                                {/* <div md={2}>
                                                    <Icon.Trash className="text-color" onClick={(e) => openModal(item)} />
                                                </div> */}
                                            </div>
                                            <div className="grid grid-cols-12 p-2 lh-base email-body">
                                                <div className="mb-3">Hey Akansha Jain,</div>
                                                <div>
                                                    {/* <strong>Subject: &nbsp;&nbsp;</strong> */}
                                                {"Veleifend. Sem viverra at sit risus habitant montes, habitant placerat tortor. Enim rutrum accumsan arcu ut a."}</div>
                                                {/* (item.subject !== "" || item.subject !== null) ? item.subject : "NA"} */}
                                                {/* <div className="p-1 act-notes-templates ml-2" dangerouslySetInnerHTML={{ __html: item.message !== "" ? `<p><strong>&nbsp;&nbsp;Message:&nbsp;&nbsp;</strong></p><div>&nbsp;&nbsp;${item.message}</div>` : "<p><strong>&nbsp;&nbsp;Message:&nbsp; </strong>NA</p>" }}></div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                        :
                        <div className="no-data mt-5">
                            <span>
                                <Icon.Inbox />
                            </span>
                            <br />
                            No Data
                        </div>
                    }
                </div>
            {/* )} */}

            {/* <DeleteModal show={dltDialog} hide={hideDialog} deleteItem={deleteEmail} /> */}

        </div>
    )
}

export default Emails;